import React from 'react'

import { GetCustomerCartQuery } from '../../graphql/magento'
import { rebateAmount } from '../../utils/priceTools'
import CartSummaryRow from './CartSummaryRow'

export interface CartAppliedRebatesProps {
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  className?: string
}

const CartAppliedRebates: React.FC<CartAppliedRebatesProps> = ({ cart, className }) => {
  if (!cart.rebate?.value) {
    return null
  }

  return (
    <CartSummaryRow className={className}>
      <div>Rebates Applied:</div>
      <div>{rebateAmount(cart)}</div>
    </CartSummaryRow>
  )
}

export default CartAppliedRebates
